import React from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';

import classes from './DaySetting.css'; 

/*
--- Props ---
day: the day of the week
displayDay: the name to display
setDayScheduleFunc: the callback function to set the schedule for this day
*/

class DaySetting extends React.Component{

    constructor(props) {
        super(props);
        // initial state
        let currentChecked = false;
        let currentTimeFrom = 0;
        let currentTimeTo = 1;
        if (this.props.currentTimeSlot != null) {
            currentChecked = true;
            currentTimeFrom = this.props.currentTimeSlot.from;
            currentTimeTo = this.props.currentTimeSlot.to;
        }
        this.state = {timeFrom: currentTimeFrom, timeTo: currentTimeTo, checked: currentChecked}
        // initialize the refs
        this.checkedInput = React.createRef(); 
        this.timeFromInput = React.createRef(); 
        this.timeToInput = React.createRef(); 
        this.options = [];
        for (let i = 0; i <= 24; i++) {
            this.options.push(<option key={i} value={i}>{this.hourToString(i)}</option>)
        }
    }

    stringToHour = (stringInput) => {
        if (stringInput === '12:00 PM') {
            return 12;
        }
        if (stringInput === '12:00 AM') {
            return 24;
        }
        else if (stringInput.slice(-2) === 'AM'){
            return parseInt(stringInput, 10);
        }
        else {
            return parseInt(stringInput, 10) + 12;
        }
    }

    hourToString = (hourInput) => {
        let hr;
        let postfix;
        if (hourInput === 12){
            hr = 12;
            postfix = 'PM';
        }
        else if (hourInput === 24){
            hr = 12;
            postfix = 'AM';
        }
        else if (hourInput < 12){
            hr = hourInput;
            postfix = 'AM';
        }
        else {
            hr = hourInput - 12;
            postfix = 'PM';
        }
        if (hr < 10){
            hr = '0' + hr;
        }
        else {
            hr = '' + hr;
        }
        return hr + ':00 ' + postfix
    }

    handleChange = () => {
        let checked = this.checkedInput.current.checked;
        let timeFrom = parseInt(this.timeFromInput.current.value, 10);

        // set from time
        this.setState({timeFrom: timeFrom, checked: checked}, () => { 
            // set to time
            let timeTo = parseInt(this.timeToInput.current.value, 10);
            this.props.setDayScheduleFunc(this.props.day, checked, timeFrom, timeTo);
        });

    }

    render(){

        let optionsFrom = this.options.slice(0, -1);
        let optionsTo = this.options.slice(this.state.timeFrom + 1,); //force timeFrom to be an int
        let checkboxId = 'day-setting-id-' + this.props.day;

        let isDisabled = true;

        if (this.state.checked===true) {
            isDisabled = false;
        }

        return (
            <Form className={classes.DaySettingRow}>
                <Form.Row>
                    <Col className={classes.DaySettingCol} xs={8} md={4}>
                        <b><Form.Check custom ref={this.checkedInput} id={checkboxId} onChange={this.handleChange} checked={this.state.checked} type="checkbox" label={this.props.displayDay}/></b>  
                    </Col>
                    <Col xs={6} md={4}>
                        <div>from <Form.Control disabled={isDisabled} ref={this.timeFromInput} onChange={this.handleChange} defaultValue={this.state.timeFrom} as="select" custom>{optionsFrom}</Form.Control></div>
                    </Col>
                    <Col xs={6} md={4}>
                        to <Form.Control disabled={isDisabled} ref={this.timeToInput} onChange={this.handleChange} defaultValue={this.state.timeTo} as="select" custom>{optionsTo}</Form.Control>
                    </Col>
                </Form.Row>
            </Form>
        );
    }
}

export default DaySetting;


// WEBPACK FOOTER //
// ./src/containers/Profile/Setting/ScheduleChange/DaySetting/DaySetting.js